import React from 'react';
import { useQuery } from '@apollo/client';
import { Chip, Box } from '@mui/material';
import { GET_CUSTOMER_PRODUCTS } from '../../../../client/queries/customer_products';

interface Product {
  id: number;
  name: string;
}

interface CustomerProductsCellProps {
  customerId: number;
}

const CustomerProductsCell: React.FC<CustomerProductsCellProps> = ({ customerId }) => {
  const { data, loading, error } = useQuery(GET_CUSTOMER_PRODUCTS, {
    variables: { customerId },
    errorPolicy: 'ignore'
  });

  if (loading) return <>Loading...</>;
  if (error || !data?.customerProducts) return <>-</>;

  const products: Product[] = data.customerProducts;

  if (products.length === 0) return <>None</>;

  // Sort products alphabetically for consistent grouping
  const sortedProducts = [...products].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, maxWidth: 200 }}>
      {sortedProducts.map((product) => (
        <Chip 
          key={product.id} 
          label={product.name} 
          size="small" 
          variant="outlined"
        />
      ))}
    </Box>
  );
};

export default CustomerProductsCell;